<template>
    <div class="quiz-textarea">
        <textarea :value="value" @input="handleInput" class="quiz-textarea__answer" rows="10" />
        <span :class="['quiz-textarea__character-limit', { 'exceeded': isCharacterLimitExceeded }]">
            <span>{{ answerLength }}/{{ characterLimit }}</span>
            <span v-if="isCharacterLimitExceeded" v-html="$t('Quiz.character_limit_exceeded')"></span>
        </span>
    </div>
</template>

<script>
    export default {
        name: 'quiz-textarea',
        props: {
            value: String
        },
        data () {
            return {
                characterLimit: 300
            }
        },
        computed: {
            answerLength () {
                return this.value.length
            },
            isCharacterLimitExceeded () {
                return this.answerLength > this.characterLimit
            }
        },
        methods: {
            handleInput ($event) {
                this.$emit('input', $event.target.value)
            }
        },
        watch: {
            answerLength: {
                handler() {
                    if (this.answerLength > 0 && !this.isCharacterLimitExceeded) {
                        this.$emit('textarea-validation-update', true )
                    } else {
                        this.$emit('textarea-validation-update', false )
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .quiz-textarea {
        &__answer {
            border: 1px solid $silver_chalice;
            border-radius: 5px;
            background: $white;
            width: 100%;
            padding: 20px;
            margin: 0 0 10px;
        }

        &__character-limit {
            font-family: PlusJakartaSans-Regular, sans-serif;
            color: $emperor;
            display: flex;
            gap: 10px;

            &.exceeded {
                color: $chestnut;
            }
        }
    }
</style>
